<div class="steps-container" *ngIf="router.url.includes('contest/rankings')">
    <div class="steps-top" [ngClass]="{'show-steps' : stepsTop}">
        <img src="../../../assets/ver-3/step-selected.svg" alt="Step Selected" style="margin-bottom: 30px;" (click)="scrollToTop()">
        <img src="../../../assets/ver-3/step.svg" alt="Step" (click)="scrollToDetails()" (scroll)="onScroll($event)">
    </div>
    <div class="steps-bottom" [ngClass]="{'show-steps' : stepsBottom}">
        <img src="../../../assets/ver-3/step-bottom.svg" alt="Step" style="margin-bottom: 30px;" (click)="scrollToTop()">
        <img src="../../../assets/ver-3/step-bottom-selected.svg" alt="Step Selected" (click)="scrollToDetails()">
    </div>
</div>